import styled from 'styled-components';

export const StyledMessageText = styled.div<{ isMobile?: boolean }>`
  .Polaris-Labelled--hidden {
    width: 100%;
  }
  .btn-add-variable {
    button.Polaris-Button {
      height: ${(props) => (props.isMobile ? '36px' : '32px')};
    }
  }
`;
